module.exports = __webpack_public_path__ + "media/images/dailySpecialMarker-9a74f22944ac86522d224bea4fd64808.png";